import MeetingsModel from '../Apis/Meetings'
import Controller from './Controller'

export default class MeetingsController extends Controller {
  constructor() {
    super(new MeetingsModel())
  }
}
